





















import { AttributesHelper } from "../../lib/utils/AttributesHelper";
import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";

/**
 * The *anx-alert* is used to delivery important messages to the user.
 * Currently the two types **error** and **success** are supported.
 */
@Component({})
export default class AnxAlert extends Vue {
  /** This is the id of the alert and will override the default unique id */
  @Prop({ default: "" }) id!: string;

  /**
   * This is the state of the alert is is usually passed via *v-model*
   * @model
   */
  @Prop({ default: false }) value!: boolean;

  /** Defines if animations like fade-in and fade-out should be used */
  @Prop({ default: true }) animations!: boolean;

  /**
   * This is the type of the alert
   * @values error, warning, success
   */
  @Prop({ default: "error" }) type!: string;

  /** If this option is set, the alert will be closed automatically after the timeout */
  @Prop({ default: null }) autoClose!: boolean | null;

  /** This is the timeout for the auto close logic */
  @Prop({ default: 5000 }) autoCloseTimeout!: number;

  /** This is the text of the alert. This can be used instead of the slot */
  @Prop({ default: "" }) text!: string;

  /** Watcher for show changes */
  @Watch("value")
  onShowChanged(val: boolean) {
    if (val) {
      this.showAction();
    } else {
      this.hideAction();
    }
  }

  /** Emit the dismiss event */
  @Emit("input")
  input(val: boolean) {
    return val;
  }

  /** Variables for anx-alert */
  visibility = false;
  fadeOut = false;
  fadeIn = false;

  /**
   * Attrbibutes for the component
   * Passing this attributes with v-bind allows to not pass unused items
   */
  private get attributes() {
    return AttributesHelper.attributes(this);
  }

  /** Set visibility when mounting */
  private created() {
    this.visibility = this.value;

    /** If the Alert is visible by default, the show action has to be called at the beginning */
    if (this.value) {
      this.showAction();
    }
  }

  /** Show the alert */
  private showAction() {
    if (this.animations) {
      this.fadeIn = true;
      if (typeof window !== "undefined") {
        window.setTimeout(() => {
          this.fadeIn = false;
          this.visibility = true;
        }, 1000);
      }
    } else {
      this.visibility = true;
    }

    /** Check if the alert should be auto closed and set a timeout */
    if (this.autoClose !== null) {
      if (typeof window !== "undefined") {
        window.setTimeout(() => {
          this.input(false);
        }, this.autoCloseTimeout);
      }
    }
  }

  /** Hide the alert */
  private hideAction() {
    if (this.animations) {
      this.fadeOut = true;
      window.setTimeout(() => {
        this.fadeOut = false;
        this.visibility = false;
      }, 1000);
    } else {
      this.visibility = false;
    }
  }
}
